import { FC } from "react";
import { useModal } from "@refinedev/antd";
import { useDelete, useNavigation } from "@refinedev/core";
import { errorNotification, successNotification } from "../../../helpers";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

type NewsDeleteProps = {
  id: number;
  name: string;
  type?: "page" | "table";
};

export const PartnersDelete: FC<NewsDeleteProps> = ({
  id,
  name,
  type = "table",
}) => {
  const { modalProps, show, close } = useModal();
  const { mutate: deleteMutate } = useDelete();
  const { push } = useNavigation();

  const handleDelete = () => {
    deleteMutate({
      dataProviderName: "partnersDataProvider",
      resource: "partners",
      id: "",
      meta: {
        id,
      },
      ...successNotification({
        successData: {
          message: `Партнер «${name}» успешно удален`,
          type: "success",
        },
        callback: () => {
          close();
          push("/partners");
        },
      }),
      ...errorNotification({}),
    });
  };

  return (
    <>
      {type === "table" ? (
        <Button
          size={"small"}
          danger
          onClick={show}
          block
          icon={<DeleteOutlined />}
        >
          Удалить
        </Button>
      ) : (
        <Button danger onClick={show} block icon={<DeleteOutlined />}>
          Удалить партнера
        </Button>
      )}

      <Modal
        okText={"Удалить"}
        cancelText={"Отмена"}
        onOk={handleDelete}
        title={"Подтверждение"}
        onCancel={close}
        {...modalProps}
      >
        Вы уверены что хотите удалить партнера «{name}»?
      </Modal>
    </>
  );
};
